import { parseDate } from '../../date-utils';

var dateCache = new WeakMap();

export default function parseDateCategory(category, row, intlService) {
    if (row === null || typeof row !== 'object') {
        return parseDate(intlService, category);
    }

    var date = dateCache.get(row);
    if (!date) {
        date = parseDate(intlService, category);
        dateCache.set(row, date);
    }

    return date;
}
